/* Liquid Glass – quick "Add to cart" for product cards.
   Works with the theme's cart drawer or cart pop-up; falls back to the cart page.
   Without JavaScript the button still works as a normal form post. */
(function () {
  if (window.__lgQuickAdd) return;
  window.__lgQuickAdd = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toast = null, toastTimer = null;

  function say(message) {
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('role', 'status');
      toast.style.cssText = 'position:fixed;left:50%;bottom:calc(120px + env(safe-area-inset-bottom,0px));transform:translate(-50%,12px);' +
        'z-index:2000;max-width:calc(100% - 40px);padding:12px 18px;border-radius:22px;background:rgba(21,33,107,.94);color:#fff;' +
        'font:600 14px/1.35 system-ui,-apple-system,sans-serif;text-align:center;opacity:0;pointer-events:none;transition:opacity .25s,transform .25s;';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    toast.style.transform = 'translate(-50%,0)';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translate(-50%,12px)';
    }, 2600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-lg-quick-add]') || !window.fetch) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var body = {
      id: Number(form.querySelector('[name="id"]').value),
      quantity: Number((form.querySelector('[name="quantity"]') || { value: 1 }).value) || 1
    };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    function finish(text) {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
      if (text) {
        btn.textContent = text;
        setTimeout(function () { btn.textContent = label; }, 1800);
      }
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || '');
        if (cart && typeof cart.renderContents === 'function' && res.sections) {
          cart.classList.remove('is-empty');
          try {
            cart.renderContents(res);
          } catch (err) {
            window.location.href = ROOT + 'cart';
            return;
          }
          finish(btn.getAttribute('data-added') || 'Added \u2713');
        } else {
          window.location.href = ROOT + 'cart';
        }
      })
      .catch(function (err) {
        finish();
        say(err && err.message ? err.message : 'Could not add this item. Please try again.');
      });
  });
})();
